import { render } from "./pageTrainCourse.vue?vue&type=template&id=2df3f193&scoped=true"
import script from "./pageTrainCourse.vue?vue&type=script&lang=js"
export * from "./pageTrainCourse.vue?vue&type=script&lang=js"

import "./pageTrainCourse.vue?vue&type=style&index=0&id=2df3f193&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df3f193"]])

export default __exports__